import React from 'react';
import classNames from 'classnames';

import css from './IconVisitCalendar.module.css';

/**
 * Calendar with a check mark, used for everything related to visits.
 * Stroke icon: the fill is forced to none so global svg styles cannot fill it.
 */
const IconVisitCalendar = ({ className }) => (
  <svg
    className={classNames(css.root, className)}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="4.5" width="18" height="16.5" rx="3" />
    <path d="M8 2.5v4M16 2.5v4M3 10h18" />
    <path d="m9 15.5 2 2 4-4" />
  </svg>
);

export default IconVisitCalendar;
